import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FOfferType, setGeo, setRange, setTerm, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';
import { setOfferType } from '../../../packages/JsonQuery/setOfferType';
import { ESuburbanOfferFilter } from '../../../packages/api-models/common/json_query';
import { setIsByDomRf } from '../../../packages/JsonQuery/setIsByDomRf';
import { setBuilders } from '../../../packages/JsonQuery/setBuilders';
import { setUndergroundTravel } from '../../../packages/JsonQuery/setUndergroundTravel';
import { IUpdateUndergroundTravelInfoPayload } from './types';

export const initialState: TJsonQuery = {
  engine_version: { type: 'term', value: 2 },
  _type: 'flatsale',
  region: {
    type: 'terms',
    value: [1],
  },
};

const jsonQuerySlice = createSlice({
  initialState,
  name: 'jsonQuery',
  reducers: {
    setJsonQuery: (_, action) => action.payload,
    updateGeo: (state, action: PayloadAction<TGeoValue[]>) => {
      return setGeo()(state)(action.payload);
    },
    setKpId: (state, action: PayloadAction<number | null>) => {
      return setTerm('kp_id')(state)(action.payload);
    },
    updateOfferType: (state, action: PayloadAction<FOfferType>) => {
      return setOfferType(state)(action.payload);
    },
    updateSuburbanOfferFilter: (state, action: PayloadAction<ESuburbanOfferFilter | null>) => {
      return setTerm('suburban_offer_filter')(state)(action.payload);
    },
    updateDomRf: (state, action: PayloadAction<boolean | null>) => {
      return setIsByDomRf(state)(action.payload);
    },
    updateBuilder: (state, action: PayloadAction<number | null>) => {
      let newJsonQuery = state;

      newJsonQuery = setBuilders(newJsonQuery)(action.payload ? [action.payload] : null);
      newJsonQuery = setTerm('builder')(newJsonQuery)(action.payload);

      return newJsonQuery;
    },
    setMinFromMkad: (state, action: PayloadAction<number | null>) => {
      return setRange('from_mcad_km')(state)(action.payload, state.from_mcad_km?.value.lte || null);
    },
    setMaxFromMkad: (state, action: PayloadAction<number | null>) => {
      return setRange('from_mcad_km')(state)(state.from_mcad_km?.value.gte || null, action.payload);
    },
    setIncludeNewMoscow: (state, action: PayloadAction<boolean | null>) => {
      return setTerm('include_new_moscow')(state)(action.payload);
    },
    updateUndergroundTravel: (state, action: PayloadAction<IUpdateUndergroundTravelInfoPayload>) => {
      const { travelType, travelTime } = action.payload;

      return setUndergroundTravel(state)(travelType, travelTime);
    },
  },
});

export const {
  reducer: jsonQueryReducer,
  actions: {
    setJsonQuery,
    setKpId,
    updateGeo,
    updateOfferType,
    updateSuburbanOfferFilter,
    updateDomRf,
    updateBuilder,
    setMinFromMkad,
    setMaxFromMkad,
    setIncludeNewMoscow,
    updateUndergroundTravel,
  },
  name: jsonQueryReducerName,
} = jsonQuerySlice;
